import { render, staticRenderFns } from "./PermitsLoader.vue?vue&type=template&id=ef0f9554&scoped=true&"
import script from "./PermitsLoader.vue?vue&type=script&lang=js&"
export * from "./PermitsLoader.vue?vue&type=script&lang=js&"
import style0 from "./PermitsLoader.vue?vue&type=style&index=0&id=ef0f9554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0f9554",
  null
  
)

export default component.exports